import { Fragment } from 'react';
import { Box } from 'components/Box';
import { ObservationCycle } from 'types/api/envScales/ObservationCycle';
import { Assessment } from 'types/api/envScales/Assessment';
import { AgeLevel } from 'types/api/envScales/AgeLevel';
import { CycleMetaDataValue } from 'types/api/envScales/CycleMetaDataValue';
import { CategoriesGrid, VerticalSeparator } from './Styled';
import MetaDataMultiSelect from '../MetaDataMultiSelect/MetaDataMultiSelect';
import MetaDataSelectOne from '../MetaDataSelectOne/MetaDataSelectOne';

interface FirstEditionMetaDataContentProps {
  /** Observation Cycle. */
  cycle: ObservationCycle;

  /** CLASS Assessment. */
  assessment: Assessment;

  /** Environmental Scales Age Level. */
  ageLevel: AgeLevel;

  /** Observation ID */
  observationId: number;

  /** Meta data values */
  values: CycleMetaDataValue[];
}

/**
 * Renders metadata content specific to CLASS First Edition assessments
 */
function FirstEditionMetaDataContent({
  cycle,
  ageLevel,
  observationId,
  values
}: FirstEditionMetaDataContentProps) {
  const selectOneFields = ageLevel.meta_data_categories
    .filter(category => category.assessment_template.class_version === 1)
    .filter(category => category.data_type === 'select_one');

  const hasSelectOneFields = selectOneFields.length > 0;

  const categoriesClassFirstEdition = ageLevel.meta_data_categories
    .filter(category => category.assessment_template.class_version === 1)
    .filter(category => category.data_type === 'multi_select')
    .filter(category => category.choices.length > 0);

  return (
    <Box mt="50px">
      <CategoriesGrid>
        {hasSelectOneFields &&
          selectOneFields.map(category => (
            <Fragment key={category.id}>
              <MetaDataSelectOne
                observationId={observationId}
                cycle={cycle}
                category={category}
                values={values}
              />
            </Fragment>
          ))}
      </CategoriesGrid>
      <CategoriesGrid>
        {categoriesClassFirstEdition.map((category, idx) => (
          <Fragment key={category.id}>
            {idx !== 0 && <VerticalSeparator />}
            <MetaDataMultiSelect
              observationId={observationId}
              cycle={cycle}
              category={category}
              values={values}
            />
          </Fragment>
        ))}
      </CategoriesGrid>
    </Box>
  );
}

export default FirstEditionMetaDataContent;
